import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { toastActions, addressesActions } from '../../../actions'
import Modal from '../../modal/modal.component'
import StyledChangeAddressModalBody from './styles/styled-change-address-modal-body.style'
import { Address } from './address.component'

class ChangeAddressModal extends Component {
	closeAndOpenNewModal = () => {
		this.props.openNewAddressModal()
	}

	closeAndOpenEditModal = index => () => {
		const { openNewAddressModal, setEditingAddressId, addresses } = this.props

		setEditingAddressId(addresses[index].id)
		openNewAddressModal()
	}

	setBillingAddress = i => {
		const { addOrUpdateAddress, addresses, addressesOwnerId } = this.props

		addresses[i].billingAddress = true
		addOrUpdateAddress(addressesOwnerId, addresses[i])
	}

	removeAddress = i => () => {
		const { inactivateAddress, addressesOwnerId, addresses } = this.props

		inactivateAddress(addressesOwnerId, addresses[i].id)
	}

	render() {
		const { isOpen, closeChangeAddressModal, addresses } = this.props

		return (
			<Modal
				onClose={closeChangeAddressModal}
				ref="changeAddressModal"
				isOpen={isOpen}
				large>
				<StyledChangeAddressModalBody>
					<div className="orange semi-bold f30">Alterar endereço</div>
					<p>Clique no endereço para selecioná-lo</p>
					<div className="addresses">
						<div
							className="add-address"
							onClick={this.closeAndOpenNewModal}>
							<FontAwesome name="plus" size="2x" />
							<span className="blue">Adicionar endereço</span>
						</div>
						{addresses &&
							addresses.map((address, index) => (
								<Address
									key={index}
									address={address}
									onRemove={this.removeAddress(index)}
									onEdit={this.closeAndOpenEditModal(index)}
									onSelect={() => this.setBillingAddress(index)}
								/>
							))}
					</div>
				</StyledChangeAddressModalBody>
			</Modal>
		)
	}
}

const mapStateToProps = ({ addresses }) => ({
	...addresses
})

const mapDispatchToPros = dispatch =>
	bindActionCreators(
		{
			danger: toastActions.danger,
			warning: toastActions.warning,
			...addressesActions
		},
		dispatch
	)

const connectedChangeAddressModal = connect(
	mapStateToProps,
	mapDispatchToPros
)(ChangeAddressModal)

export { connectedChangeAddressModal as ChangeAddressModal }
